import { useMeetingStore } from "../../stores/useMeetingStore";
import useShowError from "../utils/useShowError";
import useAxios from "./useAxios";

/**
 * host 结束会议：调用后端 EndMeeting，服务端会结束会议并广播 MeetingEnded，
 * 从而强制把所有参会者踢出会议（各自前端自动返回首页）。
 */
const useEndMeeting = () => {
    const meeting = useMeetingStore((state) => state.meeting);

    const { error, loading, setError, clearError, post } = useAxios();
    useShowError(error, clearError);

    const endMeeting = async (cb?: () => void) => {
        if (!meeting) return setError(`Missing meeting`);

        await post(`/api/meeting/EndMeeting?meetingId=${meeting.id}`);

        cb && cb();
    };

    return {
        endMeeting,
        loading,
    };
};

export default useEndMeeting;
